define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/_base/underscore",
	"csi/heading/_base",
	"csi/heading/Attribute",
	"csi/types",
	"csi/utility/dateUtility",
	"csi/widget/DateRange",
	"csi/widget/DateTextBox",
	"csi/xml"
], function(declare, lang, _, csiHeading, Attribute, types, { FORMAT_DATETIME_ZONE }, DateRange, DateTextBox, xml) {

	return declare(Attribute, {
		defaultValue: 0,
		queryOps: csiHeading.QUERY_OPS[xml.ATTR_TIME],
		tagAction: "ActionTime",
		type: xml.ATTR_TIME,

		// List<EnumValue>: working days per week
		//workingDaysPerWeek: null,

		// Date: min and max dates allowed
		//minDate: null,
		//maxDate: null,

		// Date: min and max times allowed
		//minTime: null,
		//maxTime: null,

		constructor: function(/*String*/type, /*String?*/format) {
			// summary: copy global constraints for format to pass to widget for editing
			this._setConstraints();
		},

		formatValue: function(/*Any*/value, /*String?*/fmt) {
			// summary: convert date into string with given format
			return types.formatTime(value, fmt);
		},

		getDateRangeParams: function(/*Spec*/spec, /*Object?*/extraParams) {
			// summary: return parameters to use for selecting date range
			var params = extraParams ? _.clone(extraParams) : {};
			params.popupParams = params.popupParams || {};
			params.popupParams.allowTime = false;
			params.popupParams.inPast = false;
			return params;
		},

		getQuerySpec: function(/*Context*/ctx, /*Heading*/h, /*Spec*/spec) {
			// summary: return Spec.querySpec for given heading
			var qs = this.inherited(arguments);
			qs.blanksOperator = xml.OP_BLANK_TIME;
			return qs;
		},

		toHtmlDynamic: function(/*Context*/ctx, /*Heading*/h, /*DOMNode*/refNode, /*Object*/params) {
			// summary: render editable	control for attribute - if need custom behavior for disabling values,
			// then pass isDisabledValue(Date) function as param (see DateTextBox)
			this._addDynamicParams(ctx, h, params);
			return new DateTextBox(params);
		},

		toHtmlQueryFilter: function(/*Context*/ctx, /*Spec*/spec, /*DOMNode*/refNode, /*Object*/params, /*String*/op) {
			// summary: popup date range picker
			params = params || {};

			// a value is required for date filters (empty value does not make sense)
			if (params.required == null) {
				params.required = true;
			}

			if (op == xml.OP_RANGE) {
				var dateRangeParams = this.getDateRangeParams(spec, params);
				if (dateRangeParams) {
					return new DateRange(dateRangeParams);
				}
			}

			return this.inherited(arguments);
		},

		fromHtmlDynamic: function(/*Context*/ctx, /*Heading*/h, /*Widget*/editNode) {
			// summary: return attribute value from edit control
			var dt = editNode.get("value");
			return dt && (dt instanceof Date) ? types.getDateTime(dt) : 0;
		},

		fromHtmlQueryFilter: function(/*Context*/ctx, /*Spec*/spec, /*DOMNode*/editNode, /*String*/op) {
			// summary: return attribute value from edit control
			if (op == xml.OP_RANGE) {
				return editNode.get("value");
			}

			return this.inherited(arguments);
		},

		/**
		 * @override
		 * Handle floating dates when formatting query value
		 */
		formatQueryFilterValue: function(ctx, value, format, bFloatingDates, bSelected) {
			if (_.isNumber(value) && !bFloatingDates) {
				return this.inherited(arguments);
			}

			return types.formatDateRange(value, bFloatingDates);
		},

		_addDynamicParams: function(/*Context*/ctx, /*Heading*/h, /*Object*/params) {
			// summary: return value for widget
			if (params.constraints == null) {
				params.constraints = this._constraints;
			}

			if (params.value == null) {
				params.value = this._getValue(ctx, h);
			}
		},

		_getCSS: function(/*String*/type, /*String?*/format) {
			// summary: do not factor format into CSS
			return (format === FORMAT_DATETIME_ZONE) ?
				"attrNumber attrTime attrTimeWithTimeZone" :
				"attrNumber attrTime";
		},

		_setConstraints: function() {
			// summary: setup date constraints
			var c = this._constraints = lang.delegate(types.getTimeFormatOptions(types.FORMAT_DATE));
			if (this.workingDaysPerWeek) c.workingDaysPerWeek = this.workingDaysPerWeek;
			if (this.minDate) c.min = this.minDate;
			if (this.maxDate) c.max = this.maxDate;
		},
	});
});